import { render, staticRenderFns } from "./ExpenseWarning.vue?vue&type=template&id=73842b00&scoped=true&"
import script from "./ExpenseWarning.vue?vue&type=script&lang=js&"
export * from "./ExpenseWarning.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseWarning.vue?vue&type=style&index=0&id=73842b00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73842b00",
  null
  
)

export default component.exports